// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","personalInfoSection":"personalInfoSection--u95V","input":"input-IEl5g","grid":"grid-1rYsd"};